import { actionTypes, UserEntersPhoneNumber } from "./Actions";

const userEntersPhoneNumber: UserEntersPhoneNumber = num => ({
  number: num.replace(/\s/g, ''),
  type: actionTypes.USER_ENTERS_PHONE_NUMBER
});

export default userEntersPhoneNumber;
